import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DriveFileMoveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"drive_file_move"}/>
}
